import React, { Component } from 'react';
import { Form, Row, Col, Button, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faFileCsv, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel, faFileText } from '@fortawesome/free-regular-svg-icons';
import { getInitData, getComboData, getSearchData, getSearchXls, getSearchCsv, getSearchXml } from '../Api/SearchApi';
import { saveAsFile } from "../Shared/Utils";
import Grid from '../Grid/Grid';


const gridDefault = {
    columns: [{ dataField: 'oib', text: '' }],
    data: [],
    count: 0
};


export default class searchParams extends Component {
    loaded = false;
    constructor(props) {
        super(props)
        this.state = {
            godine: [],
            konta: [],
            aktivnosti: [],
            izvori: [],
            grid: { ...gridDefault },
            searchParams: {
                godina: "",
                konto: "",
                aktivnost: "",
                izvori: "",
                oib: "",
                dobavljac: "",
                mjesto: "",
                posta: "",
                prikazati: "",
                mjesec: ""
            },
            isLoading: false,
            infoMessage: "",
            xlsFile: {
                name: "",
                base64: ""
            },
            naslov: "",
            naslovFiksni: false,
            podnozje: "",
            verzija: "",
            mjesecDefault: "",
            aktIzv: false,
            isDisabled: true,
            ucitavanje: true,
            prikazatiDefault: ""
        }
    }

    componentDidMount() {
        if (!this.loaded) this.loadOnce();
    }

    loadOnce() {
        this.loaded = true;
        getInitData()
            .then(res => {
                this.setState(prevState => ({
                    godine: res.data.godine,
                    naslov: res.data.naslov,
                    naslovFiksni: res.data.naslovFiksni,
                    podnozje: res.data.podnozje,
                    verzija: res.data.verzija,
                    mjesecDefault: res.data.mjesec,
                    aktIzv: res.data.aktIzv,
                    ucitavanje: false,
                    prikazati: res.data.prikazatiDefault,
                    searchParams: {
                        ...prevState.searchParams,
                        mjesec: res.data.mjesec,
                        prikazati: res.data.prikazatiDefault
                    }
                }));
                this.setNaslov(res.data.prikazatiDefault);
            })
            .catch(error => {
                this.handleError(error);
            })
    }

    handleError = e => {
        let err = "";
        if (e.response) {
            err = e.response.data.error;
        } else if (e.message) {
            err = e.message;
        }
        console.log("ERROR -> " + err);
        this.setState({
            infoMessage: err
        })
    }

    addGridIndex = arr => {
        let data = arr.map((e, i) => {
            return { ...e, rb: i + 1 + "." }
        })
        return data;
    }

    isDisabled = () => {
        return (this.state.isLoading || this.state.searchParams.godina === "")
    }

    setNaslov = (e) => {
        if (!this.state.naslovFiksni) {
            let naslov = "";
            if (e === "NAPUTAK") {
                naslov = 'IZVJEŠĆE O ISPLATAMA - PO NAPUTKU';
            } else if (e === "OBRACUNSKO") {
                naslov = 'IZVJEŠĆE O IZVRŠENJU PRORAČUNA PO OBRAČUNSKOM NAČELU';
            }
            this.setState({
                naslov: naslov
            })
        }
    }

    onGodinaChange = e => {
        if (e === "") return;
        getComboData(e)
            .then(res => {
                this.setState({
                    aktivnosti: res.data.aktivnosti,
                    konta: res.data.konta,
                    izvori: res.data.izvori
                })
            })
            .catch(error => {
                this.handleError(error);
            })
    }

    onPrikazatiChange = e => {
        if (e === "") return;
        this.setNaslov(e.target.value);
        this.setState(prevState => ({
            prikazati: e.target.value,
            searchParams: {
                ...prevState.searchParams,
                prikazati: e.target.value
            }
        }))
    }

    onControlChange = e => {
        let { name, value } = e.target;
        if (name === "godina") this.onGodinaChange(value);
        this.setState(prevState => ({
            searchParams: {
                ...prevState.searchParams,
                [name]: value
            }
        }))
    }

    onBtnSearch = () => {
        this.setState({ isLoading: true, infoMessage: "", grid: { ...gridDefault } });
        getSearchData(this.state.searchParams)
            .then(res => {
                if (res.data && res.data.error) {
                    throw new Error(res.data.error);
                } else {
                    //console.log(res.data);
                    let grid = {
                        columns: res.data.columns,
                        data: this.addGridIndex(res.data.data),
                        count: res.data.count
                    }
                    this.setState({
                        grid: grid,
                        isLoading: false
                    })
                }
            })
            .catch(error => {
                this.setState({ isLoading: false });
                this.handleError(error);
            })
    }

    onBtnXlsx = () => {
        this.setState({ isLoading: true, infoMessage: "", grid: { ...gridDefault } });
        getSearchXls(this.state.searchParams)
            .then(res => {
                if (res.data && res.data.error) {
                    throw new Error(res.data.error);
                } else {
                    saveAsFile(res.data.fields.FFileName, 'xls', res.data.fields.FBase64);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                this.setState({ isLoading: false });
                this.handleError(error);
            })
    }

    onBtnCsv = () => {
        this.setState({ isLoading: true, infoMessage: "", grid: { ...gridDefault } });
        getSearchCsv(this.state.searchParams)
            .then(res => {
                if (res.data && res.data.error) {
                    throw new Error(res.data.error);
                } else {
                    saveAsFile(res.data.fields.FFileName, 'csv', res.data.fields.FBase64);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                this.setState({ isLoading: false });
                this.handleError(error);
            })
    }

    onBtnXml = () => {
        this.setState({ isLoading: true, infoMessage: "", grid: { ...gridDefault } });
        getSearchXml(this.state.searchParams)
            .then(res => {
                if (res.data && res.data.error) {
                    throw new Error(res.data.error);
                } else {
                    saveAsFile(res.data.fields.FFileName, 'xml', res.data.fields.FBase64);
                    this.setState({ isLoading: false });
                }
            })
            .catch(error => {
                this.setState({ isLoading: false });
                this.handleError(error);
            })
    }

    render() {
        if (this.state.ucitavanje) {
            return (<p>Učitavanje podataka... <FontAwesomeIcon className="fa-spin" icon={faSpinner} /></p>)
        }

        let dataComponent;
        if (this.state.infoMessage !== "") {
            dataComponent = (<Alert variant="danger" onClose={() => this.setState({ infoMessage: "" })} dismissible>{this.state.infoMessage}</Alert>)
        } else if (this.state.grid.count !== 0) {
            dataComponent = (<Grid columns={this.state.grid.columns} data={this.state.grid.data} count={this.state.grid.count} podnozje={this.state.podnozje} />
            )
        }
        return (
            <>
                <h2 className="text-center">{this.state.naslov}</h2>
                <p></p>
                <Form>
                    <Row>
                        <Col xs={6} sm>
                            <Form.Group>
                                <Form.Label>Prikazati</Form.Label>
                                <Form.Select name="prikazati" onChange={e => this.onPrikazatiChange(e)} value={this.state.prikazati} >
                                    <option value="">Odaberite izvješće</option>
                                    {(this.state.verzija.indexOf('N') !== -1) ? <option value="NAPUTAK">Po Naputku</option> : ""}
                                    {(this.state.verzija.indexOf('T') !== -1) ? <option value="OBRACUNSKO">Obračunsko načelo</option> : ""}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={6} sm>
                            <Form.Group>
                                <Form.Label>Godina</Form.Label>
                                <Form.Select name="godina" onChange={e => this.onControlChange(e)}>
                                    <option value="">Odaberite godinu</option>
                                    {this.state.godine.map((obj, i) =>
                                        <option key={"godine" + i} value={obj.value}>{obj.text}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={6} sm> 
                            <Form.Group>
                                <Form.Label>Mjesec</Form.Label>
                                <Form.Select name="mjesec" onChange={e => this.onControlChange(e)} value={this.state.searchParams.mjesec}>
                                    <option value="">Svi</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        <Col xs={6} sm>
                            <Form.Group>
                                <Form.Label>Konto</Form.Label>
                                <Form.Select name="konto" onChange={e => this.onControlChange(e)}>
                                    <option value="">Sve</option>
                                    {this.state.konta.map((obj, i) =>
                                        <option key={"konta" + i} value={obj.value}>{obj.value} - {obj.text}</option>
                                    )}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                        {
                            this.state.aktIzv
                                ?
                                <Col xs={6} sm>
                                    <Form.Group>
                                        <Form.Label>Aktivnost</Form.Label>
                                        <Form.Select name="aktivnost" onChange={e => this.onControlChange(e)} disabled={!this.state.aktIzv}>
                                            <option value="">Sve</option>
                                            {this.state.aktivnosti.map((obj, i) =>
                                                <option key={"aktivnosti" + i} value={obj.value}>{obj.value} - {obj.text}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                : ""
                        }
                    </Row>
                    <p></p>
                    <Row>
                        <Col xs={6} sm>
                            <Form.Group>
                                <Form.Label>Oib</Form.Label>
                                <Form.Control name="oib" type="text" maxLength="13" onChange={e => this.onControlChange(e)} />
                            </Form.Group>
                        </Col>
                        <Col xs={6} sm>
                            <Form.Group>
                                <Form.Label>Dobavljač</Form.Label>
                                <Form.Control name="dobavljac" type="text" maxLength="40" onChange={e => this.onControlChange(e)} />
                            </Form.Group>
                        </Col>
                        <Col xs={6} sm>
                            <Form.Group>
                                <Form.Label>Mjesto</Form.Label>
                                <Form.Control name="mjesto" type="text" maxLength="30" onChange={e => this.onControlChange(e)} />
                            </Form.Group>

                        </Col>
                        <Col xs={6} sm>
                            <Form.Group>
                                <Form.Label>Pošta</Form.Label>
                                <Form.Control name="posta" type="text" maxLength="11" onChange={e => this.onControlChange(e)} />
                            </Form.Group>
                        </Col>
                        {
                            this.state.aktIzv
                                ?
                                <Col xs={6} sm>
                                    <Form.Group>
                                        <Form.Label>Izvori</Form.Label>
                                        <Form.Select name="izvori" onChange={e => this.onControlChange(e)} disabled={!this.state.aktIzv}>
                                            <option value="0">Sve</option>
                                            {this.state.izvori.map((obj, i) =>
                                                <option key={"izvori" + i} value={obj.value}>{obj.value} - {obj.text}</option>
                                            )}
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                                : ""
                        }
                    </Row>
                    <p></p>
                    <Row>
                        <Col className='d-flex justify-content-md-left'>
                            <Button variant="danger" onClick={() => this.onBtnSearch()} disabled={this.isDisabled()}>
                                <FontAwesomeIcon className={this.state.isLoading ? "fa-spin" : ""} icon={this.state.isLoading ? faSpinner : faMagnifyingGlass} /> Prikaži podatke
                            </Button>
                            &nbsp;
                            <Button variant="primary" onClick={() => this.onBtnXlsx()} disabled={this.isDisabled()}><FontAwesomeIcon icon={faFileExcel} /> Preuzmi XLSX</Button>
                            &nbsp;
                            <Button variant="success" onClick={() => this.onBtnCsv()} disabled={this.isDisabled()}><FontAwesomeIcon icon={faFileCsv} /> Prezumi CSV</Button>
                            &nbsp;
                            <Button variant="secondary" onClick={() => this.onBtnXml()} disabled={this.isDisabled()}><FontAwesomeIcon icon={faFileText} /> Prezumi XML</Button>
                        </Col>
                    </Row>
                    <p></p>
                    <Row>
                        <Col>
                            {dataComponent}
                            {/* <div>{this.state.podnozje}</div> */}
                        </Col>
                    </Row>
                </Form>
            </>
        )
    }
}
